import { useObserver } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../../app/useRoot'
import { ShopAddress } from '../../common/ShopAddress'
import { DeliveryTypeEnum, FAddressFragment } from '../../graph/generated'
import { i18n } from '../../i18n'

interface IProps {
  address: Maybe<FAddressFragment>
}

export const OrderAddress: React.FC<IProps> = ({ address }) => {
  const { order, location } = useRoot()

  return useObserver(() => {
    switch (order.orderMethod) {
      case DeliveryTypeEnum.Messenger:
        return (
          <span>
            {i18n.t`Order to address`}: <b>{location.address}</b>
          </span>
        )
      case DeliveryTypeEnum.Pickup:
        return (
          <span>
            {i18n.t`Pickup at address`}:{' '}
            <b>
              <ShopAddress address={address} />
            </b>
          </span>
        )
      default:
        return null
    }
  })
}
